"use strict";var warning=function(){};module.exports=warning;